import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import WaveDropPart from "./WaveDropPart";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ImageScale } from "@/helpers/image.helpers";
interface WaveDropContentProps {
  readonly drop: ExtendedDrop;
  readonly activePartIndex: number;
  readonly setActivePartIndex: (index: number) => void;
  readonly onDropContentClick?: ((drop: ExtendedDrop) => void) | undefined;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly onLongPress: () => void;
  readonly setLongPressTriggered: (triggered: boolean) => void;
  readonly isEditing?: boolean | undefined;
  readonly isSaving?: boolean | undefined;
  readonly onSave?: ((newContent: string) => void) | undefined;
  readonly onCancel?: (() => void) | undefined;
  readonly isCompetitionDrop?: boolean | undefined;
  readonly mediaImageScale?: ImageScale | undefined;
}
const WaveDropContent: React.FC<WaveDropContentProps> = t0 => {
  const $ = _c(14);
  const {
    drop,
    activePartIndex,
    setActivePartIndex,
    onDropContentClick,
    onQuoteClick,
    onLongPress,
    setLongPressTriggered,
    isEditing: t1,
    isSaving: t2,
    onSave,
    onCancel,
    isCompetitionDrop: t3,
    mediaImageScale: t4
  } = t0;
  const isEditing = t1 === undefined ? false : t1;
  const isSaving = t2 === undefined ? false : t2;
  const isCompetitionDrop = t3 === undefined ? false : t3;
  const mediaImageScale = t4 === undefined ? ImageScale.AUTOx450 : t4;
  let t5;
  if ($[0] !== activePartIndex || $[1] !== drop || $[2] !== isCompetitionDrop || $[3] !== isEditing || $[4] !== isSaving || $[5] !== mediaImageScale || $[6] !== onCancel || $[7] !== onDropContentClick || $[8] !== onLongPress || $[9] !== onQuoteClick || $[10] !== onSave || $[11] !== setActivePartIndex || $[12] !== setLongPressTriggered) {
    t5 = <WaveDropPart drop={drop} activePartIndex={activePartIndex} setActivePartIndex={setActivePartIndex} onDropContentClick={onDropContentClick} onQuoteClick={onQuoteClick} onLongPress={onLongPress} setLongPressTriggered={setLongPressTriggered} isEditing={isEditing} isSaving={isSaving} onSave={onSave} onCancel={onCancel} isCompetitionDrop={isCompetitionDrop} mediaImageScale={mediaImageScale} />;
    $[0] = activePartIndex;
    $[1] = drop;
    $[2] = isCompetitionDrop;
    $[3] = isEditing;
    $[4] = isSaving;
    $[5] = mediaImageScale;
    $[6] = onCancel;
    $[7] = onDropContentClick;
    $[8] = onLongPress;
    $[9] = onQuoteClick;
    $[10] = onSave;
    $[11] = setActivePartIndex;
    $[12] = setLongPressTriggered;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
export default WaveDropContent;